<div class="new-purchase-requests-modal">
    <p class="subtitle" i18n>Use the form below to upload your new data in CSV format.</p>
    <div class="purchase-request-file-picker">
        <lsq-file-picker
            [placeholderText]="attachFileI18n"
            [fileUpload]="fileUpload$ | async"
            [hideRemoveButton]="(fileUpload$ | async)?.uploading"
            (fileSourceValueChanged)="handleFileSelected($event)"
            (fileSourceElementChanged)="setFileSource($event)"
            [uploadErrorMessage]="uploadErrorMessage"
        >
        </lsq-file-picker>
    </div>

    <div class="upload" [ngClass]="{ 'upload-progress-bar': false }">
        <lsq-button
            *ngIf="!(fileUpload$ | async)?.uploading"
            i18n
            appearance="primary"
            size="md"
            [disabled]="!hasFileSelected || uploadErrorMessage"
            (buttonClick)="uploadButtonClickSubject.next()"
        >
            Upload
        </lsq-button>
    </div>
</div>
